import { render, staticRenderFns } from "./GiftMassage.vue?vue&type=template&id=24ed0697&scoped=true"
import script from "./GiftMassage.vue?vue&type=script&lang=js"
export * from "./GiftMassage.vue?vue&type=script&lang=js"
import style0 from "./GiftMassage.vue?vue&type=style&index=0&id=24ed0697&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed0697",
  null
  
)

export default component.exports